import * as actionTypes from './stateActionTypes';

const initialState={
    HiveFetchActivated: false,
    Hive:"",
    AGVFetchActivated: false,
    Agvs:[]
}

export default function stateReducer(state = initialState, action){

    switch(action.type){
        case (actionTypes.SET_HIVE_FETCH_ACTIVATED):
            if(action.fetchActivated !== state.HiveFetchActivated){
                return Object.assign({}, state,{HiveFetchActivated: action.fetchActivated});
            }
            return state

        case (actionTypes.SET_HIVE):
            if(!action.hive){
                return Object.assign({}, state,{Hive: null});
            }
            return Object.assign({}, state,{Hive: action.hive});
    
        case (actionTypes.SET_AGV_FETCH_ACTIVATED):
            if(action.fetchActivated !== state.AGVFetchActivated){
                return Object.assign({}, state,{AGVFetchActivated: action.fetchActivated});
            }
            return state

        case (actionTypes.SET_AGVS): 
            if(!action.agvs){
                
                return Object.assign({}, state,{Agvs: null});
            }

            return Object.assign({}, state,{Agvs: action.agvs});
    
        default:
            return state;
    }
}


